/*
 * CommaConsulting Js
*/

import arrowBouncer from './component/bouncingArrow'

arrowBouncer($, '.arrow')



// WEBPACK FOOTER //
// ./assets-src/js/comma.js